<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import Button from 'dashboard/components-next/button/Button.vue';

defineProps({
  list: {
    type: Object,
    default: null,
  },
});

const emit = defineEmits(['confirm']);

const { t } = useI18n();
const dialogRef = ref(null);

const open = () => {
  dialogRef.value?.open();
};

const close = () => {
  dialogRef.value?.close();
};

defineExpose({
  open,
  close,
});
</script>

<template>
  <Dialog ref="dialogRef" :title="t('CONTACT_LISTS.DELETE.TITLE')" size="small">
    <p class="text-sm text-n-slate-11">
      {{ t('CONTACT_LISTS.DELETE.DESCRIPTION') }}
    </p>
    <p v-if="list" class="mt-2 text-sm font-medium text-n-slate-12">
      {{ list.name }}
    </p>

    <template #footer>
      <div class="flex justify-end gap-2">
        <Button
          variant="faded"
          color="slate"
          :label="t('CONTACT_LISTS.DELETE.CANCEL')"
          @click="close"
        />
        <Button
          color="ruby"
          :label="t('CONTACT_LISTS.DELETE.CONFIRM')"
          @click="emit('confirm')"
        />
      </div>
    </template>
  </Dialog>
</template>
